import React, { HTMLAttributes } from 'react';
import { Box, IconButton } from '@material-ui/core';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';

type Props = HTMLAttributes<HTMLDivElement> & {
  page: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
};

const Paginator: React.FC<Props> = ({ page, total, onPrev, onNext }) => {
  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
      <IconButton disabled={page === 0} onClick={() => onPrev()}>
        <ChevronLeft />
      </IconButton>
      <Box ml={1} />
      Page {page + 1} / {total}
      <Box mr={1} />
      <IconButton disabled={page === total - 1} onClick={() => onNext()}>
        <ChevronRight />
      </IconButton>
    </Box>
  );
};

export default Paginator;
